import { Component } from '@angular/core';

@Component({
  templateUrl: '../pages/service.html'
})
export class ServiceATCComponent {

}
